module.exports = {
	"menu": {
		"menu1": "Quiénes somos",
		"menu2": "Productos",
		"menu3": "FAQs",
		"menu4": "Encuéntranos",
		"productos": {
			"producto1": "Natural",
			"producto2": "Natural 0%",
			"producto3": "Arándanos",
			"producto4": "Chocolate"
		}
	},
	"home": {
		"slides": {
			"boton1": "Nuestros productos"
		},
		"destacados": {
			"destacado1": {
				"texto1": "Resuelve tus dudas",
				"texto2": "del mundo eco",
				"boton": "Consulta las FAQs"
			},
			"destacado2": {
				"texto1": "Estamos muy",
				"texto2": "cerca de ti",
				"boton": "Dónde encontrarnos"
			}
		}
	},
	"footer": {
		"box1": {
			"title": "Conócenos mejor",
			"text1": "Las 2 vacas",
			"text2": "Nuestra historia",
			"text3": "Misión",
			"text4": "Vacálogo",
			"text5": "Proceso de elaboración"
		},
		"box2": {
			"title": "Nuestras variedades",
			"text1": "Natural",
			"text2": "0% Natural",
			"text3": "Arándanos",
			"text4": "Vacálogo",
			"text5": "Crema de chocolate"
		},
		"box3": {
			"title": "Eco y Lógico"
		},
		"box4": {
			"title": "Dónde encontrarnos"
		},
		"bottom": {
			"title": "Atención al consumidor 902 200 166",
			"text1": "Aviso legal / Política de cookies / Contacta con nosotros",
			"text2": "© Danone España 2016"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/languages/es.json
// module id = 260
// module chunks = 0